import { CartButton as CartButtonBase } from "@omni/components/components/Navigation/Buttons/CartButton/cartButton";
import { CartButtonProps } from "@omni/types/components/props/cartButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { CartButtonComponent } from "@/components/Navigation/Buttons/CartButton/cartButton.component";

export const CartButton = ({
    icon,
    alerts,
    invert,
    invertMobile,
    link,
    ariaLabel,
    text,
    textHidden,
    redirect
}: CartButtonProps<BaseStore.Hubo>) => {
    return (
        <CartButtonBase
            icon={icon}
            alerts={alerts}
            invert={invert}
            invertMobile={invertMobile}
            link={link}
            ariaLabel={ariaLabel}
            text={text}
            textHidden={textHidden}
            redirect={redirect}
        >
            <CartButtonComponent />
        </CartButtonBase>
    );
};
